export const DATAFEED_URL 					=	'https://exchange.goldfund.io';
export const SOCKET_URL 					=	'https://ng663.goldfund.io';
export const EXCHANGE_FEED_URL 				=	'/trading-view-graph-data-feed';
export const COINDETAIL_FEED_URL 			=	'/trading-view-graph-data-feed';





  


// WEBPACK FOOTER //
// src/components/TVChartContainer/api/global_constant.js